import { atom } from 'recoil'

export const modalMailupShieldState = atom({
  key: 'message__modalMailupShieldState',
  default: {
    show: false
  }
})

export const modalOpportunityState = atom({
  key: 'message__modalOpportunityState',
  default: {
    show: false,
    email: '',
    isEmailValid: true,
    type: ''
  }
})
